<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '90px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="加工组织">
              <global-select
                :value.sync="queryParams.organizationCodeList"
                selectType="selectAssembleMultiple"
                requestApi="/system/user/inventOrgList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :dropdown-match-select-width="false"
                :assembleLabel="true"
                @change="organizationCodeListChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工单分类说明">
              <global-select
                :value.sync="queryParams.idList"
                selectType="selectAssembleMultiple"
                :selectData="jobClassOptionsNew"
                :selectItem="{ value: 'realValue', label: 'selectedValue', thirdLabel: 'label' }"
                :assembleLabelThrid="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工单类型">
              <a-select show-search option-filter-prop="children" v-model="queryParams.jobTypeList" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in jobTypeOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="状态">
              <a-select v-model="queryParams.jobClassStatus" allowClear>
                <a-select-option v-for="(item) in jobClassStatus" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiJobClassNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['mes:jobClass:add']">新增</a-button>
      <a-button @click="handleExport" v-hasPermi="['mes:jobClass:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="tableLoading"
          :data-source="typeList"
          row-key="id"
          :pagination="false"
          :scroll="{ x: 1500}"
        >
          <template slot="jobType" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ jobTypeFormat(record) }}</span>
            <a-select v-if="isEdit && currentId === record.id" v-model="record.jobType" size="small">
              <a-select-option v-for="(item) in jobTypeOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
          </template>
          <template slot="updateTime" slot-scope="text">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="text">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="jobClassCode" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ record.jobClassCode }}</span>
            <a-input v-if="isEdit && currentId === record.id" v-model="record.jobClassCode" size="small" />
          </template>
          <template slot="jobClassDesc" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ record.jobClassDesc }}</span>
            <a-input v-if="isEdit && currentId === record.id" v-model="record.jobClassDesc" size="small" />
          </template>
          <template slot="jobClassStatus" slot-scope="text, record">
            <a-switch :disabled="!isEdit || currentId !== record.id" :checked="record.jobClassStatus === 'Y'" @change="statusOnChange(record)" />
          </template>
          <span slot="operation" slot-scope="text, record">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['mes:jobClass:edit']">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </a-table> -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.JOB_CLASS_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="jobType" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ jobTypeFormat(text.record) }}</span>
            <a-select v-if="isEdit && currentId === text.record.id" v-model="text.record.jobType" size="small">
              <a-select-option v-for="(item) in jobTypeOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
          </template>
          <template slot="updateTime" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="jobClassCode" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.jobClassCode }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.jobClassCode" size="small" />
          </template>
          <template slot="jobClassDesc" slot-scope="text,">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.jobClassDesc }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.jobClassDesc" size="small" />
          </template>
          <template slot="jobClassStatus" slot-scope="text">
            <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.jobClassStatus === 'Y'" @change="statusOnChange(text.record)" />
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['mes:jobClass:edit']">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>

        <!-- 底部分页按钮 -->
        <!-- <a-pagination
          class="ant-table-pagination"
          v-model="current"
          :page-size-options="pageSizeOptions"
          :total="total"
          show-size-changer
          :page-size="pageSize"
          @showSizeChange="onShowSizeChange"
          @change="currentPageChange"
        >
        </a-pagination> -->
        <!-- 创建/编辑工单分类,单独封装了组件 -->
        <job-class-add
          ref="createModal"
          :jobClassOptions="jobClassOptions"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiJobClassList, apiJobClassUpdate, apiJobClassPullDownList, apiJobClassNewExport } from '@/api/mes/basedata/jobclass'
import JobClassAdd from './components/job-class-add.vue'
import TagSelectOption from "@/components/TagSelect/TagSelectOption";
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Jobclass', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DownloadModal,
    TagSelectOption,
    JobClassAdd
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  data () {
    return {
       apiJobClassNewExport,
       // 表格配置
       tableProps: {
        requestApi: generateLsTableResData(apiJobClassList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
       // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        organizationCodeList: undefined,
        idList: undefined,
        jobTypeList: undefined,
        jobClassStatus: undefined
      },
      // 状态工单分类
      jobClassStatus: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 工单分类表格数据
      typeList: [],
      tableLoading: false,
      // 表格字段
      columns: [
        {
          title: '加工组织编码',
          dataIndex: 'organizationCode',
          width: 150,
          align: 'center'
        },
        {
          title: '加工组织',
          dataIndex: 'organizationName',
          width: 150,
          align: 'center'
        },
        {
          title: '工单分类编码',
          dataIndex: 'jobClassCode',
          width: 150,
          align: 'center'
        },
        {
          title: '说明',
          dataIndex: 'jobClassDesc',
          width: 120,
          scopedSlots: { customRender: 'jobClassDesc' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '工单类型',
          dataIndex: 'jobType',
          scopedSlots: { customRender: 'jobType' },
          width: 150,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'jobClassStatus',
          width: 100,
          scopedSlots: { customRender: 'jobClassStatus' },
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'updateBy',
          width: 100,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createBy',
          width: 100,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      jobClassOptions: [],
      jobClassOptionsNew: [], // 工单分类说明
      jobTypeOptions: [] // 工单类型
    }
  },
  created () {
    this.getList()

    const jobTypeOptionsParams = {
      lookupType: 'MES_JOB_TYPE',
      current: 1,
      pageSize: 100
    }
    this.getLookupListData(jobTypeOptionsParams).then().then(response => {
      this.jobTypeOptions = response.rows
    })
    apiJobClassPullDownList().then(response => {
      this.jobClassOptions = response.data
    })
    this.getListJobClassOptions()
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    organizationCodeListChange () {
      this.getListJobClassOptions()
    },
    getListJobClassOptions () {
      apiJobClassPullDownList({ organizationCodeList: this.queryParams.organizationCodeList }).then(response => {
        this.jobClassOptionsNew = response.data
      })
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('mes/jobClass/export', {
      //   ...this.queryParams
      // }, `工单分类_${new Date().getTime()}.xlsx`)
    },
    statusOnChange (record) {
      record.jobClassStatus = record.jobClassStatus === 'Y' ? 'N' : 'Y'
    },
    confirmHandleStatus (row) {
      // const text = row.jobClassStatus === 'Y' ? '停用' : '启用'
      row.jobClassStatus = row.jobClassStatus === 'Y' ? 'N' : 'Y'
      // apiJobClassUpdate(row)
      // .then(() => {
      //   this.$message.success(
      //     text + '成功',
      //     3
      //   )
      // }).catch(function () {
      //   row.status = row.status === 'Y' ? 'N' : 'Y'
      //   this.$message.error(
      //     text + '发生异常',
      //     3
      //   )
      // })
    },
    cancelHandleStatus (row) {
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
     // 编辑-保存
     handleSave (record) {
       apiJobClassUpdate(record).then(response => {
         if (response.code === 200) {
           this.$message.success('保存成功')
           this.onSearch()
           this.isEdit = false;
         } else {
           this.$message.error(response.msg)
         }
       })
     },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    /** 查询工单分类类型列表 */
    getList () {
      this.tableLoading = true
      apiJobClassList(this.queryParams).then(response => {
          this.typeList = response.rows
          this.total = response.total
          this.tableLoading = false
        }
      )
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
      this.isEdit = false
    },
    jobTypeFormat (row, column) {
      const datas = this.jobTypeOptions
      var actions = []
      Object.keys(datas).some((key) => {
        if (datas[key].lookupCode === ('' + row.jobType)) {
          actions.push(datas[key].lookupValue)
          return true
        }
      })
      return actions.join('')
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.pageNum = 1
      this.onSearch()
      this.isEdit = false
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        organizationCodeList: undefined,
        idList: undefined,
        jobTypeList: undefined,
        jobClassStatus: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
</style>
